import styled from 'react-emotion';

import { IconButton as BaseIconButton } from '@ublend-npm/aulaui-next';

const IconButton = styled(BaseIconButton)`
  margin-left: 8px;
`;

export default IconButton;
